import { FunctionComponent } from 'preact';
import { Book } from '@novelizing/types';
import './BookCard.css';
import { PlaceholderCover } from '../PlaceholderCover';

interface BookCardProps {
  book: Book;
}

export const BookCard: FunctionComponent<BookCardProps> = ({ book }) => {
  const formattedDate = new Date(book.createdAt).toLocaleDateString();

  const cdnUrl = import.meta.env.VITE_CDN_URL || '';
  const baseBookCoverImageUrl = '/uploads/covers/';

  return (
    <div className="book-card">
      <div className="book-cover">
        <a
          href={`/f/${book.permalink}`}
          className="book-cover-link"
          title={book.title}
        >
          {book.coverImageMed ? (
            <img
              src={`${cdnUrl}${baseBookCoverImageUrl}${book.coverImageMed}`}
              alt={`Cover for ${book.title}`}
            />
          ) : (
            <PlaceholderCover text={book.title} size="medium" />
          )}
        </a>
      </div>
      <div className="book-info">
        <h3 className="book-title">
          <a href={`/f/${book.permalink}`} className="book-title-link">
            {book.title}
          </a>
        </h3>
        <p className="book-author">
          by{' '}
          <a href={`/u/${book.user.username}`}>
            {book.user.name || book.user.username}
          </a>
        </p>
        {book.elevatorPitch && (
          <p className="elevator-pitch">{book.elevatorPitch}</p>
        )}
        {book.genres && (
          <ul className="tag-list">
            {book.genres.map((genre) => (
              <li key={genre.permalink}>
                <a className="tag" href={`/genre/${genre.permalink}`}>
                  {genre.title}
                </a>
              </li>
            ))}
          </ul>
        )}

        <p className="book-stats">
          {book.wordCount.toLocaleString()} words
          {book.backlogWordCount > 0 &&
            ` · ${book.backlogWordCount.toLocaleString()} backlog`}
        </p>
        <p className="book-date">Published: {formattedDate}</p>
      </div>
    </div>
  );
};
